export default __webpack_public_path__ + "static/media/guidance.10bb16cd.svg";